import React, { useState, useEffect, useRef } from 'react';
import {
    Typography,
    Button,
    Form,
    Input,
    Space,
    InputNumber,
    Card,
    Divider,
    Row,
    Col,
    message,
    Tooltip,
    Spin,
    Modal,
    Collapse,
    Radio,
    Table
} from 'antd';
import {
    DeleteOutlined,
    PlusCircleOutlined,
    ExclamationCircleOutlined,
    QuestionCircleOutlined,
    DollarOutlined,
    ReloadOutlined,
    RightOutlined,
    LeftOutlined,
} from '@ant-design/icons';
import SidebarLayout from '../BankerUI/SidebarLayout';
import _BankerService from '../../modules/BankerService';
import { COMMON_ERROR_MSG } from '../../constants/constants';
import { routes } from '../../routes/Routes';
import { useHistory, useLocation } from "react-router-dom";
import CurrencyInput from '../../components/CurrencyInput';
import PercentInput from '../../components/PercentInput';
import PhoneInput from "react-phone-input-auto-format";
// import ApplicationList from './ApplicationList';
import DonutChart from '../../components/DonutChart';
import IntegerInput from '../../components/IntergerInput';
import ApplicationList from '../BankerUI/ApplicationList';
import moment from 'moment';
import _commonService from '../../modules/commonService';
import IntegerDecimalInput from '../../components/IntegerDecimalInput';

const { Title, Text } = Typography;
const { confirm } = Modal;
const { Panel } = Collapse;

const FirmAdminSponsersDetails = () => {
    const addClickedRef = useRef(false);
    const [form] = Form.useForm();
    const history = useHistory();
    const location = useLocation();
    const [allApplications, setAllApplications] = useState([]);
    const [autoFocusApplicantIndex, setAutoFocusApplicantIndex] = useState(null);

    let data = location.state;
    let sponsId = 0;
    if (data && data.sponserId) {
        sponsId = data.sponserId;
    }

    const [sponserId] = useState(sponsId);

    const [loading, setLoading] = useState(false);
    const [sponserData, setSponserData] = useState([]);
    const [activePanelKey, setActivePanelKey] = useState(['1']);
    const [searchTerm, setSearchTerm] = useState("");
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [sortBy, setSortBy] = useState(null);
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [debouncedSearchText, setDebouncedSearchText] = useState("");
    const [applicationStatus, setApplicationStatus] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [password, setPassword] = useState("");
    const [passwordError, setPasswordError] = useState("");

    const showModal = () => {
        setIsModalOpen(true);
        setPassword("");
        setPasswordError("");
    };

    const handleOk = async () => {
        if (!password.trim()) {
            setPasswordError("Banker Login Password is required");
            return;
        }

        let reqObj = {
            "BankerPassword": password,
            "BankerId": Number(localStorage.getItem("BankerId")),
            "SponserId": sponserId
        }

        setLoading(true);
        try {
            const res = await _BankerService.deleteSponserApplicantsData(reqObj);
            if (res.data.IsSuccess) {
                message.success(res.data.Message);
                setPasswordError("");
                setIsModalOpen(false);
                history.push(routes.sponsors.path);
                // getSponserDataBySponserId(sponserId);
                // getApplicationListBySponserId(sponserId);
            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        setPassword("");
        setPasswordError("");
    };

    useEffect(() => {
        // getApplicationListBySponserId(sponserId));
        if (sponserId && sponserId > 0) {
            getApplicationListBySponserId(sponserId);
            setActivePanelKey([]);
        }
    }, [debouncedSearchText, applicationStatus, toDate, sortBy, pageIndex, pageSize]);

    useEffect(() => {
        if (debouncedSearchText !== "") {
            setPageIndex(1);
            setPageSize(10);
        }
    }, [debouncedSearchText]);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearchText(searchTerm && searchTerm.trim());
        }, 900);

        return () => {
            clearTimeout(handler);
        };
    }, [searchTerm]);

    const getApplicationListBySponserId = async () => {
        const params = {
            sponserId: sponserId,
            ByAppStatus: applicationStatus,
            startDate: fromDate ? moment(fromDate).format("YYYY-MM-DD") : "",
            endDate: toDate ? moment(toDate).format("YYYY-MM-DD") : "",
            pageIndex,
            pageSize,
            searchTerm: debouncedSearchText,
            sortBy,
            sortAsc: true,
        };

        setLoading(true);
        try {
            const res = await _BankerService.getApplicationListBySponserId(params);
            if (res.data.IsSuccess) {
                let resObj = res?.data?.Obj?.List;
                setAllApplications(resObj);
                setTotalCount(res?.data?.Obj?.TotalRecords || 0);
                setLoading(false);
            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG);
                setLoading(false);
            }
        } catch (error) {
            message.error(COMMON_ERROR_MSG);
        } finally {
            setLoading(false);
        }
    };

    const handleClearFilters = () => {
        setSearchTerm("");
        setFromDate(null);
        setToDate(null);
        setSortBy(null);
        setApplicationStatus(0);
        setPageIndex(1);
        setPageSize(10);
    };

    const handlePaginationChange = (page, size) => {
        setPageIndex(page);
        setPageSize(size);
    };

    useEffect(() => {
        if (sponserId && sponserId > 0) {
            getSponserDataBySponserId();
        } else {
            setSponserData({ applicants: [{ name: '', contactNumber: '', email: '', gpCommitment: null, roleId: "", }] })
        }
    }, []);

    const getSponserDataBySponserId = async () => {
        try {
            setLoading(true);

            const res = await _BankerService.getSponserDataBySponserId(sponserId);

            if (res.data.IsSuccess) {
                setLoading(false);
                let resObj = res.data.Obj;
                setSponserData({
                    ...resObj,
                    firm: resObj.CompanyName,
                    businessPhone: resObj.ContactNumber,
                    typeOfBusiness: resObj.TypeOfBusiness,
                    yearsAssociated: resObj.YearsAssociated,
                    streetAddress: resObj.StreetAddress,
                    city: resObj.City,
                    state: resObj.State,
                    zip: resObj.ZipCode,
                    interestRate: resObj.IntrestExpense,
                    underWritingObjId: resObj?.underWritingModel?.Id,
                    tdsrThresholdvalue: resObj?.underWritingModel?.TdsrThresholdvalue,
                    leverageThresholdvalue: resObj?.underWritingModel?.LeverageThresholdvalue,
                    cbrThresholdvalue: resObj?.underWritingModel?.CbrThresholdvalue,
                    debtIncomeRatioThresholdvalue: resObj?.underWritingModel?.DebtIncomeRatioThresholdvalue,
                    applicants: resObj.sponserApplicantModels && resObj.sponserApplicantModels.map((obj) => {
                        return {
                            id: obj.Id,
                            sponserId: obj.SponserId,
                            bankerId: Number(localStorage.getItem("BankerId")),
                            name: obj.ApplicantName,
                            contactNumber: obj.ApplicantPhone,
                            email: obj.ApplicantEmail,
                            confirmemail: obj.ApplicantEmail,
                            gpCommitment: obj.ProspectiveGPCommitmentAmount
                                ? Number(obj.ProspectiveGPCommitmentAmount)
                                : null,
                            // interestExpense: obj.IntrestExpense,
                            isApplicantRegistered: obj.IsApplicantRegistered,
                            lastEmailSentDateTime: obj.LastEmailSentDateTime,
                            roleId: obj.RoleId
                        };
                    })
                });
            } else {
                setLoading(false);
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (error) {
            setLoading(false);
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => form.resetFields(), [sponserData]);


    const onFinish = async (values) => {
        console.log('Form Values:', values);
        const firmAdminsCount =
            (values.applicants || []).filter(app => Number(app.roleId) === 6).length;

        if (firmAdminsCount === 0) {
            message.error("At least one Firm Admin is required.");
            setLoading(false);
            return;
        }

        if (firmAdminsCount > 1) {
            message.error("Only one applicant can be assigned the Firm Admin role.");
            setLoading(false);
            return;
        }
        setLoading(true);
        let reqObj = {
            "Id": sponserId || 0,
            "CompanyName": values.firm,
            "ContactNumber": values.businessPhone,
            "TypeOfBusiness": values.typeOfBusiness,
            "YearsAssociated": values.yearsAssociated,
            "TotalProgrameSize": values.TotalProgrameSize,
            "AdvanceRate": values.AdvanceRate,
            "MaxLTV": values.MaxLTV,
            "IntrestExpense": values.interestRate,
            "StreetAddress": values.streetAddress,
            "City": values.city,
            "State": values.state,
            "ZipCode": values.zip,
            "BankerId": Number(localStorage.getItem("BankerId")),
            "underWritingModel": {
                "Id": sponserData && sponserData.underWritingObjId > 0 ? sponserData.underWritingObjId : 0,
                "TdsrThresholdvalue": values.tdsrThresholdvalue,
                "LeverageThresholdvalue": values.leverageThresholdvalue,
                "CbrThresholdvalue": values.cbrThresholdvalue,
                "DebtIncomeRatioThresholdvalue": values.debtIncomeRatioThresholdvalue,
            },
            "sponserApplicantModels": values.applicants && values.applicants.map((obj) => {
                return {
                    Id: obj.id || 0,
                    SponserId: sponserId > 0 ? sponserId : 0,
                    BankerId: Number(localStorage.getItem("BankerId")),
                    ApplicantName: obj.name,
                    ApplicantPhone: obj.contactNumber,
                    ApplicantEmail: obj.email,
                    ProspectiveGPCommitmentAmount: obj.gpCommitment,
                    RoleId: obj.roleId
                    // IntrestExpense: obj.interestExpense
                };
            })
        }

        const emails = values.applicants?.map(app => app.email?.toLowerCase().trim()) || [];
        const duplicateEmails = emails.filter((email, index) => emails.indexOf(email) !== index);

        if (duplicateEmails.length > 0) {
            const uniqueDuplicates = [...new Set(duplicateEmails)];
            message.error(`Duplicate Applicant Email(s) found: ${uniqueDuplicates.join(', ')}`);
            setLoading(false);
            return;
        }

        try {
            const res = await _BankerService.addUpdateSponser(reqObj);
            if (res.data.IsSuccess) {
                setLoading(false);
                message.success(res.data.Message);
                history.push({ pathname: routes.sponsors.path });
            } else {
                setLoading(false);
                message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
            }
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
        finally {
            setLoading(false);
        }
    };

    const onBack = () => {
        history.push(routes.sponsors.path);
    }

    // console.log("sponserData++", sponserData);
    // console.log("applicants--", form.getFieldValue('applicants'));
    // console.log("A", sponserData && sponserData.applicants && sponserData.applicants.length == 0);
    // console.log("B", form.getFieldValue('applicants') && form.getFieldValue('applicants').length == 0);          


    const handleDeleteApplicant = (field, remove, form, index) => {
        const applicants = form.getFieldValue('applicants');
        const applicant = applicants?.[field.name];

        confirm({
            title: <span>Are you sure you want to delete this Applicant <Text className='f16' strong>{applicant && applicant.email ? `(${applicant.email})` : ""}</Text>?</span>,
            icon: <ExclamationCircleOutlined />,
            width: 500,
            okText: <span id="yesBtn">Yes</span>,
            cancelText: <span id="noBtn">No</span>,
            okType: "primary",
            async onOk() {
                if (applicant?.id && applicant.id > 0) {
                    // This record exists in DB → call delete API
                    try {
                        setLoading(true);
                        const res = await _BankerService.deleteSponserApplicantById(applicant.id);
                        if (res.data.IsSuccess) {
                            message.success(res.data.Message || 'Applicant deleted successfully');
                            remove(field.name);
                            getSponserDataBySponserId(sponserId);
                        } else {
                            message.error(res.data.Message || COMMON_ERROR_MSG);
                            setLoading(false);
                        }
                    } catch (error) {
                        console.log(error);
                        setLoading(false);
                    } finally {
                        setLoading(false);
                    }
                } else {
                    // New unsaved record → just remove from form
                    remove(index);
                }
            }
        });
    };

    const handleResendEmailOTP = (field, form) => {
        const applicants = form.getFieldValue('applicants');
        const applicant = applicants?.[field.name];

        confirm({
            title: <span>Are you sure you want to resend the OTP to this applicant's email <Text className='f16' strong>{applicant && applicant.email ? `(${applicant.email})` : ""}</Text>?</span>,
            icon: <ExclamationCircleOutlined />,
            width: 500,
            okText: <span id="yesBtn">Yes</span>,
            cancelText: <span id="noBtn">No</span>,
            okType: "primary",
            async onOk() {
                if (applicant?.id && applicant.id > 0) {

                    const reqObj =
                    {
                        "Id": applicant.id,
                        "ApplicantName": applicant.name,
                        "ApplicantPhone": applicant.contactNumber,
                        "ApplicantEmail": applicant.email,
                        "ProspectiveGPCommitmentAmount": applicant.gpCommitment,
                        "RoleId": applicant.roleId,
                        // "IntrestExpense": applicant.interestExpense,
                        "BankerId": applicant.bankerId || Number(localStorage.getItem("BankerId")),
                        "SponserId": applicant.sponserId || sponserId
                    }

                    try {
                        setLoading(true);
                        const res = await _BankerService.resendApplicantEmailOTP(reqObj);
                        if (res.data.IsSuccess) {
                            message.success(res.data.Message || 'OTP sent successfully');
                            getSponserDataBySponserId(sponserId);
                        } else {
                            message.error(res.data.Message || COMMON_ERROR_MSG);
                            setLoading(false);
                        }
                    } catch (error) {
                        console.log(error);
                        setLoading(false);
                    } finally {
                        setLoading(false);
                    }
                }
            }
        });
    };


    // const onUnderWriteBtnClick = () => {
    //     history.push({
    //         pathname: routes.applicantUnderwritingCriteria.path,
    //         state: { sponserId: sponserId },
    //     });
    // }

    const isAnyApplicantEmpty = () => {
        const applicants = form.getFieldValue('applicants') || [];

        return applicants.some(app => {
            return (
                (app?.name || "").trim() === "" &&
                (app?.contactNumber || "").trim() === "" &&
                (app?.email || "").trim() === "" &&
                (app?.gpCommitment === null || app?.gpCommitment === "")
                // (app?.interestExpense === null || app?.interestExpense === "")
            );
        });
    };

    // const handleCollapseChange = (key) => {
    //     const isCollapsing = activePanelKey.includes('1');
    //     if (addClickedRef.current) {
    //         addClickedRef.current = false;
    //         setActivePanelKey(key);
    //         return;
    //     }

    //     if (isCollapsing && isAnyApplicantEmpty()) {
    //         message.warning("Please complete all fields for each applicant or remove empty applicants");
    //         return;
    //     }
    //     setActivePanelKey(key);
    // };

    // ✅ Function to handle role change
    const handleRoleChange = (e, field, form) => {
        const selectedValue = e.target.value;
        const applicants = form.getFieldValue("applicants") || [];

        if (selectedValue === 6) {
            // Count other Firm Admins (excluding current row)
            const firmAdminCount = applicants.filter(
                (app, idx) => idx !== field.name && Number(app.roleId) === 6
            ).length;

            if (firmAdminCount >= 1) {
                message.error("Only one Firm Admin can be selected.");
                const updatedApplicants = [...applicants];
                updatedApplicants[field.name] = {
                    ...updatedApplicants[field.name],
                    roleId: undefined,
                };
                form.setFieldsValue({ applicants: updatedApplicants });
            }
        }
    };


    return (
        <Spin spinning={loading}>
            <SidebarLayout>
                <div className='baseAlign' style={{ justifyContent: "space-between" }}>

                    <h4 level={3} className="title">
                        Credit Facility Details
                        <div><text className="dashboard-subtitle">Set up and manage firm-level Credit Facility configurations.</text></div>
                    </h4>

                    <Space>
                        <Button
                            icon={<LeftOutlined />}
                            onClick={() => history.goBack()}
                        >
                            Back
                        </Button>

                        {/* {sponserId && sponserId > 0 ?
                            <Button
                                type="primary"
                                onClick={onUnderWriteBtnClick}
                                className='ml20'
                            >Add Applicant Underwriting Criteria</Button>
                            : <></>
                        } */}

                        {sponserId && (sponserId > 0) ?
                            <div className='displayNone'>
                                <Button
                                    type='primary'
                                    className='ml20'
                                    onClick={showModal}
                                >
                                    Delete Loan Program
                                </Button>
                            </div> :
                            <></>
                        }
                    </Space>
                </div>
                <Card className='add-edit-sponsers' >
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={onFinish}
                        initialValues={sponserData}
                        className='inputDisabledBlackColor'
                    >
                        <Row gutter={16}>

                            {/* LEFT SIDE — ALL CONTENT */}
                            <Col xs={24} lg={18}>

                                {/* Firm Information */}
                                <div className='borderBox mr10'>
                                    <Col>

                                        <Title level={5}>Firm Information</Title>
                                        <Row gutter={[16, 16]}>
                                            <Col
                                                className="gutter-row"
                                                xs={24} md={12}
                                            >
                                                <Form.Item
                                                    label="Firm (Applicant Employer)"
                                                    name="firm"
                                                    rules={[{ required: true, message: 'Firm (Applicant Employer) is required' }]}
                                                >
                                                    <Input
                                                        placeholder='Enter Firm (Applicant Employer)'
                                                        disabled
                                                    // disabled={sponserId && sponserId > 0 ? true : false}
                                                    />
                                                </Form.Item>
                                            </Col>

                                            <Col
                                                className="gutter-row"
                                                xs={24} md={12}
                                            >
                                                <Form.Item
                                                    label="Business Phone"
                                                    name="businessPhone"
                                                    rules={[{ required: true, message: 'Business Phone is required' }]}
                                                >
                                                    <PhoneInput
                                                        disabled
                                                        placeholder="Enter Business Phone"
                                                        inputComponent={Input}
                                                        autoComplete="off"
                                                        onChange={(value) => {
                                                            const digits = value.replace(/\D/g, '');
                                                            form.setFieldsValue({ businessPhone: digits });
                                                        }}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col
                                                className="gutter-row"
                                                xs={24} md={12}
                                            >
                                                <Form.Item
                                                    label="Type Of Business"
                                                    name="typeOfBusiness"
                                                    rules={[{ required: true, message: 'Type Of Business is required' }]}
                                                >
                                                    <Input
                                                        placeholder='Enter Type Of Business'
                                                        disabled
                                                    // disabled={sponserId && sponserId > 0 ? true : false}
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>

                                    </Col>
                                    ...
                                </div>

                                {/* Program Configuration */}
                                <div className='borderBox mt20 mr10'>
                                    <Col>

                                        <Title level={5}>Program Configuration</Title>
                                        <Row gutter={[16, 16]}>
                                            <Col
                                                className="gutter-row"
                                                xs={24} md={12}
                                            >
                                                <Form.Item
                                                    label="Total Program Size $"
                                                    name="TotalProgrameSize"
                                                    rules={[{ required: true, message: 'Total Program Size is required' }]}
                                                >
                                                    <CurrencyInput
                                                        disabled
                                                        placeholder="Enter Total Program Size"
                                                    />
                                                </Form.Item>
                                            </Col>

                                            {sponserId && sponserId > 0
                                                && Number(sponserData?.LoanProgrameTypeId) !== 2
                                                && Number(sponserData?.LoanProgrameTypeId) !== 4 && (
                                                    <Col
                                                        className="gutter-row"
                                                        xs={24} md={12}
                                                    >
                                                        <Form.Item
                                                            label="Advance Rate %"
                                                            name="AdvanceRate"
                                                            rules={[
                                                                { required: true, message: 'Advance Rate is required' },
                                                                {
                                                                    validator: (_, value) => {
                                                                        if (!value || (/^\d{1,3}$/.test(value) && parseInt(value, 10) <= 999)) {
                                                                            return Promise.resolve();
                                                                        }
                                                                        return Promise.reject(new Error('Enter a valid 3-digit number (0-999)'));
                                                                    },
                                                                },
                                                            ]}
                                                        >
                                                            <IntegerInput maxLength={3}
                                                                placeholder="Enter Advance Rate"
                                                                disabled
                                                            />
                                                        </Form.Item>
                                                    </Col>
                                                )}
                                            {sponserId && sponserId > 0
                                                && Number(sponserData?.LoanProgrameTypeId) !== 2
                                                && Number(sponserData?.LoanProgrameTypeId) !== 4 && (

                                                    <Col
                                                        className="gutter-row"
                                                        xs={24} md={12}
                                                    >
                                                        <Form.Item
                                                            label="Max LTV %"
                                                            name="MaxLTV"
                                                            rules={[
                                                                { required: true, message: 'Max LTV is required' },
                                                                {
                                                                    validator: (_, value) => {
                                                                        if (!value || (/^\d{1,3}$/.test(value) && parseInt(value, 10) <= 999)) {
                                                                            return Promise.resolve();
                                                                        }
                                                                        return Promise.reject(new Error('Enter a valid 3-digit number (0-999)'));
                                                                    },
                                                                },
                                                            ]}
                                                        >
                                                            <IntegerInput maxLength={3}
                                                                placeholder="Enter Max LTV"
                                                                disabled
                                                            />
                                                        </Form.Item>
                                                    </Col>

                                                )}

                                            <Col
                                                className="gutter-row"
                                                xs={24} md={12}
                                            >
                                                <Form.Item
                                                    label="Interest Rate %"
                                                    name="interestRate"
                                                    rules={[
                                                        { required: true, message: 'Interest Rate is required' },
                                                        // {
                                                        //     validator: (_, value) => {
                                                        //         if (!value || (/^\d{1,3}$/.test(value) && parseInt(value, 10) <= 999)) {
                                                        //             return Promise.resolve();
                                                        //         }
                                                        //         return Promise.reject(new Error('Enter a valid 3-digit number (0-999)'));
                                                        //     },
                                                        // },
                                                    ]}
                                                >
                                                    <IntegerDecimalInput maxLength={5}
                                                        placeholder="Enter Interest Rate"
                                                        disabled
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>

                                    </Col>
                                    ...
                                </div>

                                {/* Address Details */}
                                <div className='borderBox mt20 mr10'>
                                    <Col>

                                        <Title level={5}>Address Details</Title>
                                        <Row gutter={[16, 16]}>
                                            <Col
                                                className="gutter-row"
                                                xs={24} md={24}
                                            >
                                                <Form.Item
                                                    label="Street Address"
                                                    name="streetAddress"
                                                    rules={[{ required: true, message: 'Street Address is required' }]}
                                                >
                                                    <Input
                                                        placeholder='Enter Street Address'
                                                        disabled
                                                    // disabled={sponserId && sponserId > 0 ? true : false}

                                                    />
                                                </Form.Item>
                                            </Col>

                                            <Col
                                                className="gutter-row"
                                                xs={24} md={12}
                                            >
                                                <Form.Item
                                                    label="City"
                                                    name="city"
                                                    rules={[{ required: true, message: 'City is required' }]}
                                                >
                                                    <Input
                                                        placeholder='Enter City'
                                                        disabled
                                                    // disabled={sponserId && sponserId > 0 ? true : false}

                                                    />
                                                </Form.Item>
                                            </Col>

                                            <Col
                                                className="gutter-row"
                                                xs={24} md={12}
                                            >
                                                <Form.Item
                                                    label="State"
                                                    name="state"
                                                    rules={[{ required: true, message: 'State is required' }]}
                                                >
                                                    <Input
                                                        disabled
                                                        placeholder='Enter State'
                                                    // disabled={sponserId && sponserId > 0 ? true : false}

                                                    />
                                                </Form.Item>
                                            </Col>

                                            <Col
                                                className="gutter-row"
                                                xs={24} md={12}
                                            >
                                                <Form.Item
                                                    label="Zip Code"
                                                    name="zip"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Zip Code is required',
                                                        },
                                                        {
                                                            pattern: /^\d{5}(-\d{4})?$/,
                                                            message: 'Enter a valid ZIP Code (e.g., 12345 or 12345-6789)',
                                                        },
                                                    ]}
                                                >
                                                    <IntegerInput
                                                        disabled
                                                        placeholder='Enter Zip Code'
                                                        maxLength={10}
                                                    // disabled={sponserId && sponserId > 0 ? true : false}
                                                    />
                                                </Form.Item>
                                            </Col>

                                            {/* <Col
                                className="gutter-row"
                                xs={{ span: 12 }}
                                lg={{ span: 12 }}
                                md={{ span: 12 }}
                                sm={{ span: 8 }}
                                xl={{ span: 8 }}
                            >
                                <Form.Item
                                    label="Years Associated"
                                    name="yearsAssociated"
                                    rules={[{ required: true, message: 'Years Associated is required' }]}
                                >
                                    <IntegerInput
                                        placeholder="Enter Years Associated"
                                    // disabled={sponserId && sponserId > 0 ? true : false}
                                    />
                                </Form.Item>
                            </Col> */}

                                        </Row>

                                    </Col>

                                </div>

                                {/* Underwriting Criteria */}
                                {sponserId && sponserId > 0
                                    && Number(sponserData?.LoanProgrameTypeId) !== 2
                                    && Number(sponserData?.LoanProgrameTypeId) !== 4 && (
                                        <div className='borderBox mt20 mr10'>
                                            <Col>

                                                <Title level={5}>Set Applicant Underwriting Criteria</Title>
                                                <Row gutter={[16, 16]}>
                                                    <Col
                                                        className="gutter-row"
                                                        xs={24} md={12}
                                                    >
                                                        <Form.Item
                                                            name="tdsrThresholdvalue"
                                                            label="TDSR Threshold %"
                                                            rules={[{ required: true, message: "TDSR Threshold % is required" }]}
                                                        >
                                                            <IntegerInput
                                                                placeholder="Enter TDSR Threshold %"
                                                                maxLength={3}
                                                                disabled
                                                            />
                                                        </Form.Item>
                                                    </Col>

                                                    <Col
                                                        className="gutter-row"
                                                        xs={24} md={12}
                                                    >
                                                        <Form.Item
                                                            name="leverageThresholdvalue"
                                                            label="Leverage Threshold"
                                                            rules={[{ required: true, message: "Leverage Threshold is required" }]}
                                                        >
                                                            <IntegerDecimalInput
                                                                placeholder="Enter Leverage Threshold"
                                                                maxLength={10}
                                                                disabled
                                                            />
                                                        </Form.Item>
                                                    </Col>

                                                    <Col
                                                        className="gutter-row"
                                                        xs={24} md={12}
                                                    >
                                                        <Form.Item
                                                            name="cbrThresholdvalue"
                                                            label="CBR Threshold"
                                                            rules={[{ required: true, message: "CBR Threshold is required" }]}
                                                        >
                                                            <IntegerInput
                                                                placeholder="Enter CBR Threshold"
                                                                maxLength={10}
                                                                disabled
                                                            />
                                                        </Form.Item>
                                                    </Col>

                                                    <Col
                                                        className="gutter-row"
                                                        xs={24} md={12}
                                                    >
                                                        <Form.Item
                                                            name="debtIncomeRatioThresholdvalue"
                                                            label="Debt Income Ratio Threshold"
                                                            rules={[{ required: false, message: "Debt Income Ratio Threshold is required" }]}
                                                        >
                                                            <IntegerDecimalInput
                                                                placeholder="Enter Debt Income Ratio Threshold"
                                                                maxLength={10}
                                                                disabled
                                                            />
                                                        </Form.Item>
                                                    </Col>
                                                </Row>

                                            </Col>
                                            ...
                                        </div>
                                    )}
                            </Col>

                            {/* RIGHT SIDE — ONLY LOAN UTILIZATION */}
                            <Col xs={24} lg={6}>

                                {sponserId && sponserId > 0 ?
                                    <Card className='borderBox'>
                                        <Row justify="space-around" align="middle" >
                                            {/* Left - Donut chart */}
                                            <Col>
                                                <Row
                                                    className="iconFont"
                                                    align="middle"
                                                    justify="center"
                                                    style={{ marginBottom: 16 }}
                                                >
                                                    <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                                                        <Text
                                                            strong
                                                            className="ant-card-head-title"
                                                            style={{ fontSize: 16, margin: 0 }}
                                                        >
                                                            Loan Utilization Summary
                                                        </Text>
                                                        {/* <Tooltip title="What is Limit Usage?">
                                                            <QuestionCircleOutlined className="limit-usage-icon" />
                                                        </Tooltip> */}
                                                    </div>
                                                </Row>

                                                <div style={{ textAlign: "center" }}>

                                                    <DonutChart data={[
                                                        { type: 'Remaining', value: Number(sponserData && sponserData.Remaining) },
                                                        { type: 'Utilized', value: Number(sponserData && sponserData.Utilized) },

                                                    ]}
                                                        title="Budget"
                                                    />
                                                </div>
                                            </Col>

                                            {/* Right - Active Loans */}
                                            {/* <Col>
                                                <Space direction="vertical" size={8}>
                                                    <Title
                                                        level={5}
                                                        style={{
                                                            fontWeight: 600,
                                                            fontSize: 16,
                                                            marginBottom: 0,
                                                        }}
                                                    >
                                                        <DollarOutlined /> Active Loan Programs
                                                    </Title>
                                                    <Text style={{ fontSize: 14 }}>
                                                        In Progress: <strong>{sponserData && sponserData.Inprogressed || "0"}</strong>
                                                    </Text>
                                                    <Text style={{ fontSize: 14 }}>
                                                        Approved: <strong>{sponserData && sponserData.Approved || "0"}</strong>
                                                    </Text>
                                                </Space>
                                            </Col> */}
                                        </Row>
                                    </Card>

                                    : <></>}

                            </Col>

                        </Row>

                        {sponserId && sponserId > 0
                            && Number(sponserData?.LoanProgrameTypeId) !== 2
                            && Number(sponserData?.LoanProgrameTypeId) !== 4 && (
                                <Row>
                                    <Col xs={24} lg={18}>
                                        <div className='borderBox mt20 mr10'>
                                            <Title level={5}>Applicant List</Title>
                                            <Table
                                                dataSource={allApplications}
                                                rowKey={(record) => record.Id || record.ApplicationId}
                                                loading={loading}
                                                pagination={false}
                                                className="transparent-table"
                                                columns={[
                                                    {
                                                        title: "Individual Client Name",
                                                        key: "individualClientName",
                                                        render: (_, record) =>
                                                            [record.FirstName, record.MiddleName, record.LastName].filter(Boolean).join(" ") || "N/A",
                                                    },
                                                    {
                                                        title: "Email",
                                                        dataIndex: "Email",
                                                        render: (value) => value || "N/A",
                                                    },
                                                    {
                                                        title: "Confirm Email",
                                                        dataIndex: "Email",
                                                        render: (value) => value || "N/A",
                                                    },
                                                    {
                                                        title: "Contact Number",
                                                        dataIndex: "Phone",
                                                        render: (value) => (value ? _commonService.formatUSPhoneNumber(value) : "N/A"),
                                                    },
                                                    {
                                                        title: "Approved Loan Amount $",
                                                        dataIndex: "LoanEnquiryFor",
                                                        render: (value) => (value ? `$${_commonService.formatNumberWithCommas(value)}` : "N/A"),
                                                    },
                                                    {
                                                        title: "Application Status",
                                                        dataIndex: "Application_Status",
                                                        render: (value) => {
                                                            const normalized = (value || "").toLowerCase();
                                                            let color = "rgba(244,244,245,0.7)";
                                                            let background = "rgba(244,244,245,0.08)";
                                                            if (normalized.includes("fund")) {
                                                                color = "#4ADE80";
                                                                background = "rgba(34,197,94,0.12)";
                                                            } else if (normalized.includes("review")) {
                                                                color = "#3B82F6";
                                                                background = "rgba(59,130,246,0.12)";
                                                            } else if (normalized.includes("declin") || normalized.includes("reject")) {
                                                                color = "#F87171";
                                                                background = "rgba(248,113,113,0.12)";
                                                            } else if (normalized.includes("approv")) {
                                                                color = "#F59E0B";
                                                                background = "rgba(245,158,11,0.12)";
                                                            }
                                                            return (
                                                                <span
                                                                    style={{
                                                                        display: "inline-block",
                                                                        padding: "2px 10px",
                                                                        borderRadius: 4,
                                                                        fontSize: 12,
                                                                        color,
                                                                        background,
                                                                    }}
                                                                >
                                                                    {value || "N/A"}
                                                                </span>
                                                            );
                                                        },
                                                    },
                                                ]}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            )}

                        {sponserId && (sponserId > 0) ?
                            <div className='displayNone'>
                                {loading ? <Spin /> :
                                    <ApplicationList
                                        allApplications={allApplications}
                                        loading={loading}
                                        pageIndex={pageIndex}
                                        pageSize={pageSize}
                                        totalCount={totalCount}
                                        onPaginationChange={handlePaginationChange}
                                        searchTerm={searchTerm}
                                        fromDate={fromDate}
                                        toDate={toDate}
                                        sortBy={sortBy}
                                        onSearchChange={setSearchTerm}
                                        fromDateChange={setFromDate}
                                        toDateChange={setToDate}
                                        onSortChange={setSortBy}
                                        onClearFilters={handleClearFilters}
                                        onApplicationStatusChange={setApplicationStatus}
                                        applicationStatusForFilter={applicationStatus}
                                    />
                                }
                            </div>
                            : <></>
                        }

                        <Collapse
                            className={sponserId && sponserId > 0 ? 'mt75 collapseHeaderColor displayNone' : 'mt40 collapseHeaderColor displayNone'}
                            activeKey={activePanelKey}
                            onChange={(keys) => setActivePanelKey(keys)}
                            expandIcon={({ isActive }) => (
                                <div
                                    style={{
                                        width: 24,
                                        height: 24,
                                        borderRadius: "50%",
                                        backgroundColor: "#414957",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        transition: "transform 0.3s",
                                        transform: isActive ? "rotate(-90deg)" : "rotate(90deg)",
                                    }}
                                >
                                    <RightOutlined style={{ color: "white", fontSize: 12 }} />
                                </div>
                            )}

                        >
                            <Panel
                                key="1"
                                showArrow={true}
                                // collapsible={sponserId && sponserId > 0 ? undefined : "disabled"}
                                header={
                                    <div
                                        onClick={() => {
                                            // Only allow toggle if sponserId > 0
                                            if (!(sponserId > 0)) return;

                                            if (isAnyApplicantEmpty()) {
                                                message.warning("Please enter all fields for each applicant or remove empty applicants");
                                                return;
                                            }

                                            setActivePanelKey((prevKeys) =>
                                                prevKeys.includes("1") ? [] : ["1"]
                                            );
                                        }}
                                        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
                                    >
                                        <Title level={5} style={{ margin: 0 }}>
                                            Individual Applicant Details
                                        </Title>
                                        {/* {(form.getFieldValue('applicants') || []).length === 0 && ( */}
                                        <Button
                                            type="primary"
                                            icon={<PlusCircleOutlined />}
                                            onClick={(e) => {
                                                e.stopPropagation(); // Prevent header toggle
                                                addClickedRef.current = true;

                                                const existing = form.getFieldValue('applicants') || [];
                                                form.setFieldsValue({
                                                    applicants: [...existing, {
                                                        name: "",
                                                        contactNumber: "",
                                                        email: "",
                                                        gpCommitment: null,
                                                        roleId: "",
                                                        // interestExpense: ""
                                                    }]
                                                });

                                                setAutoFocusApplicantIndex(existing.length);
                                                setActivePanelKey(['1']); // Keep panel open
                                            }}
                                        >
                                            Add Applicant
                                        </Button>
                                    </div>
                                }
                            >
                                <Form.List name="applicants">
                                    {(fields, { add, remove }) => (
                                        <>
                                            {fields.map((field, index) => (
                                                <Card
                                                    key={field.key}
                                                    type="inner"
                                                    style={{ marginBottom: 16 }}
                                                >
                                                    {console.log(field, "field name")}
                                                    <Row gutter={[16, 16]}>
                                                        <Col
                                                            className="gutter-row"
                                                            xs={{ span: 12 }}
                                                            lg={{ span: 12 }}
                                                            md={{ span: 12 }}
                                                            sm={{ span: 8 }}
                                                            xl={{ span: 8 }}
                                                        >
                                                            <Form.Item
                                                                {...field}
                                                                label="Individual Applicant Name"
                                                                name={[field.name, 'name']}
                                                                fieldKey={[field.fieldKey, 'name']}
                                                                rules={[
                                                                    { required: false, message: 'Individual Applicant Name is required' },
                                                                ]}
                                                            >
                                                                <Input
                                                                    placeholder="Enter Individual Applicant Name"
                                                                    ref={input => {
                                                                        if (autoFocusApplicantIndex === index && input) {
                                                                            input.focus();
                                                                            setAutoFocusApplicantIndex(null); // reset so it doesn't repeat
                                                                        }
                                                                    }}
                                                                    disabled={form.getFieldValue('applicants')[field.name].isApplicantRegistered ? true : false}
                                                                />
                                                            </Form.Item>
                                                        </Col>

                                                        <Col
                                                            className="gutter-row"
                                                            xs={{ span: 12 }}
                                                            lg={{ span: 12 }}
                                                            md={{ span: 12 }}
                                                            sm={{ span: 8 }}
                                                            xl={{ span: 8 }}
                                                        >
                                                            <Form.Item
                                                                {...field}
                                                                label="Email"
                                                                name={[field.name, 'email']}
                                                                fieldKey={[field.fieldKey, 'email']}
                                                                rules={[
                                                                    { required: true, message: 'Email is required' },
                                                                    { type: 'email', message: 'Enter a valid Email' },
                                                                    // ({ getFieldValue }) => ({
                                                                    //     validator(_, value) {
                                                                    //         const applicants = getFieldValue("applicants") || [];
                                                                    //         const email = value?.toLowerCase().trim();
                                                                    //         const duplicateCount = applicants.filter(
                                                                    //             (item, i) =>
                                                                    //                 i !== index &&
                                                                    //                 item?.email?.toLowerCase().trim() === email
                                                                    //         ).length;

                                                                    //         if (duplicateCount > 0) {
                                                                    //             return Promise.reject(new Error("Duplicate email found"));
                                                                    //         }

                                                                    //         return Promise.resolve();
                                                                    //     },
                                                                    // }),
                                                                ]}
                                                            >
                                                                <Input
                                                                    placeholder="Enter Email"
                                                                    disabled={form.getFieldValue('applicants')[field.name].isApplicantRegistered ? true : false}
                                                                    maxLength={50}
                                                                />
                                                            </Form.Item>
                                                        </Col>


                                                        <Col
                                                            className="gutter-row"
                                                            xs={{ span: 12 }}
                                                            lg={{ span: 12 }}
                                                            md={{ span: 12 }}
                                                            sm={{ span: 8 }}
                                                            xl={{ span: 8 }}
                                                        >
                                                            <Form.Item
                                                                {...field}
                                                                label="Confirm Email"
                                                                name={[field.name, 'confirmemail']}
                                                                fieldKey={[field.fieldKey, 'confirmemail']}
                                                                dependencies={[[field.name, 'email']]}
                                                                rules={[
                                                                    { required: true, message: 'Confirm Email is required' },
                                                                    { type: 'email', message: 'Enter a valid Email' },
                                                                    ({ getFieldValue }) => ({
                                                                        validator(_, value) {
                                                                            const email = getFieldValue(['applicants', field.name, 'email']);
                                                                            if (!value || email === value) {
                                                                                return Promise.resolve();
                                                                            }
                                                                            return Promise.reject(new Error("Email and Confirm Email do not match"));
                                                                        }
                                                                    })
                                                                ]}
                                                            >
                                                                <Input
                                                                    placeholder="Enter Confirm Email"
                                                                    onCopy={(e) => e.preventDefault()}
                                                                    onCut={(e) => e.preventDefault()}
                                                                    onPaste={(e) => e.preventDefault()}
                                                                    disabled={form.getFieldValue('applicants')[field.name].isApplicantRegistered ? true : false}
                                                                    maxLength={50}
                                                                />
                                                            </Form.Item>
                                                        </Col>

                                                        <Col
                                                            className="gutter-row"
                                                            xs={{ span: 12 }}
                                                            lg={{ span: 12 }}
                                                            md={{ span: 12 }}
                                                            sm={{ span: 8 }}
                                                            xl={{ span: 8 }}
                                                        >
                                                            <Form.Item
                                                                {...field}
                                                                label="Contact Number"
                                                                name={[field.name, 'contactNumber']}
                                                                fieldKey={[field.fieldKey, 'contactNumber']}
                                                                rules={[
                                                                    { required: true, message: 'Contact Number is required' },
                                                                    {
                                                                        validator: (_, value) => {
                                                                            if (!value) {
                                                                                return Promise.resolve(); //  Allow empty value if not required
                                                                            }
                                                                            const digits = value.replace(/\D/g, '');
                                                                            if (digits.length === 10) {
                                                                                return Promise.resolve();
                                                                            }
                                                                            return Promise.reject(
                                                                                new Error("Wrong format! please use this format (XXX) XXX-XXXX")
                                                                            );
                                                                        },
                                                                    }
                                                                ]}
                                                            >
                                                                <PhoneInput
                                                                    placeholder="Enter Contact Number"
                                                                    inputComponent={Input}
                                                                    autoComplete="off"
                                                                    onChange={(value) => {
                                                                        // Remove non-digit characters and store the raw number
                                                                        const digits = value.replace(/\D/g, '');
                                                                        const applicants = form.getFieldValue('applicants') || [];
                                                                        const updatedApplicants = [...applicants];
                                                                        updatedApplicants[field.name] = {
                                                                            ...updatedApplicants[field.name],
                                                                            contactNumber: digits
                                                                        };
                                                                        form.setFieldsValue({ applicants: updatedApplicants });
                                                                    }}
                                                                    disabled={form.getFieldValue('applicants')[field.name].isApplicantRegistered ? true : false}
                                                                />
                                                            </Form.Item>
                                                        </Col>

                                                        <Col
                                                            className="gutter-row"
                                                            xs={{ span: 12 }}
                                                            lg={{ span: 12 }}
                                                            md={{ span: 12 }}
                                                            sm={{ span: 8 }}
                                                            xl={{ span: 8 }}
                                                        >
                                                            <Form.Item
                                                                {...field}
                                                                label="Prospective GP Commitment Amount $"
                                                                name={[field.name, 'gpCommitment']}
                                                                fieldKey={[field.fieldKey, 'gpCommitment']}
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: 'Prospective GP Commitment Amount is required',
                                                                    },
                                                                ]}
                                                            >
                                                                <CurrencyInput
                                                                    placeholder="Enter Prospective GP Commitment Amount"
                                                                    maxLength={20}
                                                                    disabled={form.getFieldValue('applicants')[field.name].isApplicantRegistered ? true : false}
                                                                />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col
                                                            className="gutter-row"
                                                            xs={{ span: 12 }}
                                                            lg={{ span: 12 }}
                                                            md={{ span: 12 }}
                                                            sm={{ span: 8 }}
                                                            xl={{ span: 8 }}
                                                        >
                                                            <Form.Item
                                                                label="Select Role"
                                                                name={[field.name, 'roleId']}
                                                                rules={[{ required: true, message: "Please select a role!" }]}
                                                            >
                                                                <Radio.Group
                                                                    onChange={(e) => handleRoleChange(e, field, form)}
                                                                    value={form.getFieldValue("applicants")[field.name]?.roleId}
                                                                    disabled={form.getFieldValue('applicants')[field.name].isApplicantRegistered ? true : false}
                                                                >
                                                                    <Radio value={6}>Firm Admin</Radio>
                                                                    <Radio value={7}>Applicant</Radio>
                                                                </Radio.Group>
                                                            </Form.Item>
                                                        </Col>



                                                        {/* <Col
                                                            className="gutter-row"
                                                            xs={{ span: 12 }}
                                                            lg={{ span: 12 }}
                                                            md={{ span: 12 }}
                                                            sm={{ span: 8 }}
                                                            xl={{ span: 8 }}
                                                        >
                                                            <Form.Item
                                                                {...field}
                                                                label="Interest Expense %"
                                                                name={[field.name, 'interestExpense']}
                                                                fieldKey={[field.fieldKey, 'interestExpense']}
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: 'Interest Expense % is required',
                                                                    },
                                                                    {
                                                                        pattern: /^\d+(\.\d{1,2})?$/,
                                                                        message: "Enter a valid amount",
                                                                    }
                                                                ]}
                                                            >
                                                                <PercentInput
                                                                    placeholder="Enter Interest Expense %"
                                                                    maxLength={20}
                                                                    disabled={form.getFieldValue('applicants')[field.name].isApplicantRegistered ? true : false}
                                                                />
                                                            </Form.Item>
                                                        </Col> */}



                                                    </Row>

                                                    <Row gutter={[16, 16]}>
                                                        <Col
                                                            className="gutter-row" style={{ display: 'flex', alignItems: 'center' }}
                                                            xs={{ span: 12 }}
                                                            lg={{ span: 12 }}
                                                            md={{ span: 12 }}
                                                            sm={{ span: 8 }}
                                                            xl={{ span: 8 }}
                                                        >
                                                            <Space>
                                                                {fields.length > 0 && (
                                                                    <>
                                                                        <Tooltip
                                                                            title={
                                                                                form.getFieldValue('applicants')[field.name].isApplicantRegistered
                                                                                    ? null
                                                                                    : 'Delete Applicant'
                                                                            }
                                                                        >
                                                                            <Button
                                                                                type="text"
                                                                                icon={
                                                                                    <DeleteOutlined
                                                                                        className={form.getFieldValue('applicants')[field.name].isApplicantRegistered ? 'iconDisabledColor' : ""}
                                                                                    />
                                                                                }
                                                                                onClick={() => handleDeleteApplicant(field, remove, form, index)}
                                                                                disabled={form.getFieldValue('applicants')[field.name].isApplicantRegistered ? true : false}
                                                                            />
                                                                        </Tooltip>

                                                                        {(form.getFieldValue('applicants')[field.name].id) > 0 && !(form.getFieldValue('applicants')[field.name].isApplicantRegistered) && (
                                                                            <div className='blockAlign'>
                                                                                <Tooltip title="Resend Email OTP">
                                                                                    <Button
                                                                                        type="link"
                                                                                        icon={<ReloadOutlined />}
                                                                                        onClick={() => handleResendEmailOTP(field, form)}
                                                                                    >
                                                                                        Resend Email OTP
                                                                                    </Button>
                                                                                </Tooltip>
                                                                                <Tooltip title={`Last verification Email sent on ${form.getFieldValue('applicants')[field.name].lastEmailSentDateTime ? _commonService.formatDateTimeAMPM(form.getFieldValue('applicants')[field.name].lastEmailSentDateTime) : null}`}>
                                                                                    <div>{form.getFieldValue('applicants')[field.name].lastEmailSentDateTime ? _commonService.formatDateTimeAMPM(form.getFieldValue('applicants')[field.name].lastEmailSentDateTime) : null}</div>
                                                                                </Tooltip>
                                                                            </div>
                                                                        )
                                                                        }
                                                                    </>
                                                                )}
                                                                {index === fields.length - 1 && (
                                                                    <Button
                                                                        type="link"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            e.stopPropagation();
                                                                            const newApplicant = {
                                                                                id: 0,
                                                                                name: "",
                                                                                contactNumber: "",
                                                                                email: "",
                                                                                gpCommitment: null,
                                                                                roleId: "",
                                                                                // interestExpense: "",
                                                                                isApplicantRegistered: false
                                                                            };

                                                                            add(newApplicant);
                                                                            setAutoFocusApplicantIndex(fields.length); // set focus index to the new field
                                                                        }}
                                                                        icon={<PlusCircleOutlined />}
                                                                    >
                                                                        Add Applicant
                                                                    </Button>
                                                                )}
                                                            </Space>
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            ))}
                                        </>
                                    )}
                                </Form.List>

                                {sponserData && sponserData.applicants && sponserData.applicants.length == 0 &&
                                    form.getFieldValue('applicants') && form.getFieldValue('applicants').length == 0 &&
                                    (
                                        <div className="textCenterAlign">No Applicants added yet</div>
                                    )}
                            </Panel>
                        </Collapse>

                        {/* <Divider /> */}

                        <div className="mt10 displayNone" style={{ display: "flex", justifyContent: "flex-end", gap: 16 }}>

                            <Form.Item>
                                <Button disabled
                                    onClick={onBack}
                                    icon={<LeftOutlined />}
                                >
                                    Go Back
                                </Button>

                            </Form.Item>

                            <Form.Item>
                                <Button type="primary" disabled htmlType="submit">
                                    Save
                                </Button>
                            </Form.Item>
                        </div>
                    </Form>
                </Card>

                <Modal
                    title="Delete Loan Program"
                    open={isModalOpen}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    closable
                >
                    <Text strong>Note: This action will delete Loan Program & all the Individual Applicants under this Loan Program <Text strong>({sponserData && sponserData.firm})</Text></Text>
                    <div>
                        <label className="label-align mt10">Banker Login Password<span className="asterick-color">*</span></label>
                    </div>
                    <Input.Password
                        autoComplete="current-password"
                        placeholder="Enter Banker Login Password"
                        maxLength={30}
                        value={password}
                        onChange={(e) => {
                            setPassword(e.target.value);
                            setPasswordError("");
                        }}
                    />
                    {passwordError && (
                        <div style={{ display: "block", marginTop: 8, color: "#ff4d4f" }}>
                            {passwordError}
                        </div>
                    )}
                </Modal>
            </SidebarLayout>
        </Spin>
    );
};

export default FirmAdminSponsersDetails;